import React, { useEffect } from 'react';

import * as net from "../../lib/net";
import ddo from '../../ddo.js'

import SDOContext from "../../sdo";
import Dt_Cal from "../../lib/ui/dt_cal";
import Pay_Add from "./pays/pay_add";
import Term_Edit from "./term/term_edit";

function web01() {

    var html =
        <h4>Huvud</h4>
    ;
    return html;
}

class Bo_TDef extends React.Component {

  constructor(props, context) {
    super(props);

    this.webStore = props.store;
    this.pos = props.store.pos;

    this.state = {};
    this.state.seldate = new Date();
    this.state.avd = ddo.cache.avd;
    this.state.taa = [];
    this.state.aa = [];
    this.state.tdo = {};
    this.state.wnds = {};
    if(this.pos.deps) this.state.aa = this.pos.deps;
  }
  componentDidUpdate() {
  }
  componentWillUnmount() {
  }
  componentDidMount() {
    this.tdef();
  }

  body_style() {
      var css = {};
      css.height = window.innerHeight - 280;
      return css;
  }
  tb_style() {
      var css = {};
      css.height = window.innerHeight - 280;
      return css;
  }
  onUnitChange(e) {
        this.setState({unit: e.value});
  }

  dep_show() {
    var self = this;
    //alert(JSON.stringify(this.props.store));
  }

  dep_add() {
    var self = this;

    if(!this.pos.deps) {
        this.pos.deps = [];
        this.pos.deps.push( {"id": "01", "text": "DEP 01" } );
        this.pos.deps.push( {"id": "02", "text": "DEP 02" } );
        this.pos.deps.push( {"id": "03", "text": "DEP 03" } );
    }
    this.pos.deps.push( {"id": "04", "text": "DEP 04" } );
    self.setState({aa: this.pos.deps });
  }

    pay_new() {
        var self = this;
        var wnds = {};
        wnds.payadd = true;
        wnds.pbo = {};
        self.setState({wnds: wnds });
    }
    term_add() {
        var self = this;
        //alert(JSON.stringify(row.bet00));
        //var bto = JSON.parse(JSON.stringify(row.bet00));
        var wnds = {};
        wnds.termadd = true;
        //wnds.tdo = row;
        wnds.backdrop = true;
        self.setState({wnds: wnds });
    }
    term_edit(row) {
        var self = this;
        //alert(JSON.stringify(row.bet00));
        //var bto = JSON.parse(JSON.stringify(row.bet00));
        var wnds = {};
        wnds.termedit = true;
        wnds.tdo = row;
        wnds.backdrop = true;
        self.setState({wnds: wnds });
    }

  tdef() {
    var self = this;

    var prm = {};
    prm.req = "pos.pos_term.terms";
    prm.avd = this.state.avd;

    net.sio_req(prm)
    .then(function(ret){
        //alert(JSON.stringify(ret.rca));

        self.setState({taa: ret.rca });
    })
    .catch(function(e){
        var txt = JSON.stringify(e);
    });
  }
  change_avd(e) {
    //let cdat = this.state.seldate;
    let avd = e.target.value;
    this.setState({avd: avd});
  }

  render() {
    return (
    <div className="web-app">

    <div className="flex-row">
        <select className="form-control w250" placeholder="Välj avdelning" onChange={(e) => this.change_avd(e)}>
            { this.props.store.pos.deps.map((row, key) =>
            <option key={key} value={row.avd}>{row.avd} - {row.text}</option>
            )}
        </select>
        <div className="flex"></div>

        <button className="btn btn-hw-blue w150" onClick={() => this.term_add() } aria-label="System" >
            LÄGG TILL
        </button>
        <button className="btn btn-hw-blue w150" onClick={() => this.tdef() } aria-label="System" >
            Visa
        </button>
    </div>
    <div className="divider_orange"></div>

    <div className="web-row">
        <table className="table table-bordered table-hover tb fixed_header">
            <thead>
            <tr>
                <th>Termnr</th>
                <th>Avd</th>
                <th>Prn</th>
                <th>Emvnr</th>
                <th>Uppdat</th>
            </tr>
            </thead>
            <tbody style={ this.tb_style() }>
            { this.state.taa.map((row, key) =>
            <tr key={key} onDoubleClick={() => this.term_edit(row) }>
                <td>{ row.ter00.z0ttynr }</td>
                <td>{ row.ter00.z0kst }</td>
                <td>{ row.ter00.z0rptprt }</td>
                <td>{ row.ter00.z0emvnr }</td>
                <td>{ row.ter00.z0upddat }</td>
            </tr>
            )}
            </tbody>
        </table>
    </div>

        { this.state.wnds.termadd ? <Pay_Add wnds={ this.state.wnds } ctx={this} store={this.props.store} backdrop={true}/> : null }
        { this.state.wnds.termedit ? <Term_Edit wnds={ this.state.wnds } ctx={this} store={this.props.store} backdrop={true}/> : null }
    </div>
  );
    }
}
export default Bo_TDef;
